export const useReactiveModelMixin = (property = 'value', propertyDefinition = undefined, isModel = true) => {
  const EVENT_NAME_UPDATE_MODEL = `update:${property}`
  const PROPERTY_NAME_UPPERCASE = property.charAt(0).toUpperCase() + property.slice(1)
  const PROPERTY_NAME_LOCAL = `local${PROPERTY_NAME_UPPERCASE}`

  const mixin = {
    props: {
      [property]: propertyDefinition
    },
    emits: [ EVENT_NAME_UPDATE_MODEL ],
    data () {
      return {
        local: {
          [property]: null
        }
      }
    },
    computed: {
      [PROPERTY_NAME_LOCAL]: {
        get () {
          return this.local[property]
        },
        set (value) {
          if (this.local[property] !== value) {
            this.local[property] = value
            this.$emit(EVENT_NAME_UPDATE_MODEL, value)
          }
        }
      }
    },
    watch: {
      [property] (newValue) {
        if (newValue !== this[PROPERTY_NAME_LOCAL]) {
          this[PROPERTY_NAME_LOCAL] = newValue
        }
      }
    },
    created () {
      this.local[property] = this[property]
    }
  }

  if (isModel) {
    mixin.model = {
      prop: property,
      event: EVENT_NAME_UPDATE_MODEL
    }
  }

  return mixin
}



// WEBPACK FOOTER //
// ./src/components/nexum/mixins/useReactiveModelMixin.js